var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0666 9.34169V5.76668C20.0666 4.45039 18.9996 3.38334 17.6833 3.38334H3.38333C2.06705 3.38334 1 4.45039 1 5.76668V9.34169M20.0666 9.34169V20.0667C20.0666 21.383 18.9996 22.45 17.6833 22.45H3.38333C2.06705 22.45 1 21.383 1 20.0667V9.34169M20.0666 9.34169H1M5.76665 1V5.76668M15.3 1V5.76668",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderSurvey);
export default __webpack_public_path__ + "static/media/calender-survey.bcae06b0297d45f45d8e84ed320eeaac.svg";
export { ForwardRef as ReactComponent };